import { render, staticRenderFns } from "./StreamLabelTemplate.vue?vue&type=template&id=4dda26c3&scoped=true"
import script from "./StreamLabelTemplate.vue.ts?vue&type=script&lang=ts&external"
export * from "./StreamLabelTemplate.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./StreamLabelTemplate.vue?vue&type=style&index=0&id=4dda26c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda26c3",
  null
  
)

export default component.exports